// Warten, bis DOM geladen ist
document.addEventListener('DOMContentLoaded', () => {
    waitForGoogleMaps(initTuluxMap);
});

function waitForGoogleMaps(callback) {
    const maxRetries = 50;
    let count = 0;
    const interval = setInterval(() => {
        if (window.google && google.maps && google.maps.importLibrary) {
            clearInterval(interval);
            callback();
        } else if (++count >= maxRetries) {
            clearInterval(interval);
            console.warn('Google Maps API konnte nicht geladen werden.');
        }
    }, 100);
}

async function initTuluxMap() {
    const tuluxMap = document.getElementById('tulux-map');
    if (!tuluxMap) return;

    const mapMarkers = [
        { position: { lat: 47.201504, lng: 8.943781 } },
        { position: { lat: 46.940518, lng: 6.839764 } }
    ];

    const mapCenter = { lat: 47.147450, lng: 7.947251 };

    function zoomResponsive() {
        const width = window.innerWidth;
        if (width >= 1400) return 8;
        if (width >= 1068) return 9;
        if (width >= 540) return 8;
        return 7;
    }

    function createIconElement() {

        const pathsElement = document.getElementById('icon-path');
        const iconPath     = pathsElement.dataset.icons;
        const url          = new URL(iconPath).pathname;
        const icon         = document.createElement('div');

        icon.className = 'custom-map-pin';
        icon.style.backgroundImage = 'url("' + url + '/tulux-marker.png")';
        icon.style.width = '60px';
        icon.style.height = '60px';
        icon.style.backgroundSize = 'contain';
        icon.style.backgroundRepeat = 'no-repeat';
        return icon;
    }

    try {

        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const map = new Map(tuluxMap, {
            center: mapCenter,
            zoom: zoomResponsive(),
            mapId: "6e9ef008d0ccc7bcb36b2e2b"
        });

        mapMarkers.forEach(marker => {
            new AdvancedMarkerElement({
                position: marker.position,
                map: map,
                content: createIconElement()
            });
        });

        const updateZoom = () => map.setZoom(zoomResponsive());
        window.addEventListener('load', updateZoom);
        window.addEventListener('resize', updateZoom);
    } catch (err) {
        console.error("Google Maps konnte nicht initialisiert werden:", err);
    }
}
